export const ADMIN_GROUPS_BASE = '/app/admin/user_groups'
